import { Table, TableCell, TableProps, TableRow } from "@mui/material";
import formatCurrency from "system/formatCurrency";
import { AversiLine } from "../AversiSessionsPage";

interface Props extends TableProps {
	lines : AversiLine[]
}

const AversiLinesTable = ({ lines, ...rest } : Props) => (
	<Table {...rest}>
		{lines.map(line => {
			return (
				<TableRow key={line.id}>
					<TableCell>{`${line.month}/${line.year}`}</TableCell>
					<TableCell>{line.file?.filename}</TableCell>
					<TableCell>{line.productCode}</TableCell>
					<TableCell align="right">{formatCurrency(line.amount)}</TableCell>
				</TableRow>
			)
		})}
	</Table>
);

export default AversiLinesTable;
